/* eslint-disable complexity */
import angular from 'angular';
import template from './templates/dropdown-multiselect-kt.tmpl.html';

export default function DropdownMultiselect($timeout) {
    'ngInject';
    return {
        restrict: 'AE',
        template,
        bindToController: true,
        controller: DropdownMultiselectController,
           scope: {
            options: '=options',
            model: '=model',
            extraSettings: '=',
            events: '=',
            searchFilter: '=?',
            translationTexts: '=',
            disabled: '=',
            details: '@',
            styling: '@',
        },
        link: function(scope, elem, attr) {
            scope.id = attr.details;
            scope.btnId = scope.id + 'Menu';
            scope.style = attr.styling;
            scope.element = null;
            scope.btn = null;
            $timeout(function() {
                scope.element = angular.element('#' + scope.id);
                scope.btn = angular.element('#' + scope.btnId);
            }, 100);
        },
    };

    function DropdownMultiselectController($scope, $element, l10nService, $filter) {
        'ngInject';

        const externalEvents = {
            onItemSelect: angular.noop,
            onItemDeselect: angular.noop,
            onSelectAll: angular.noop,
            onDeselectAll: angular.noop,
            onInitDone: angular.noop,
            onMaxSelectionReached: angular.noop,
            onSelectionChanged: angular.noop,
            onClose: angular.noop,
        };

        const settings = {
            dynamicTitle: true,
            scrollable: false,
            scrollableHeight: '300px',
            closeOnBlur: true,
            displayProp: 'text',
            enableSearch: true,
            enableSearchLimit: 10,
            clearSearchOnClose: true,
            selectionLimit: 0,
            showCheckAll: true,
            showUncheckAll: true,
            showEnableSearchButton: false,
            closeOnSelect: false,
            buttonClasses: 'btn btn-default',
            closeOnDeselect: false,
            groupBy: undefined,
            checkBoxes: true,
            groupByTextProvider: null,
            smartButtonMaxItems: 0,
            smartButtonTextConverter: angular.noop,
            styleActive: false,
            selectedToTop: false,
            keyboardControls: false,
            template: '{{getPropertyForObject(option, settings.displayProp)}}',
            searchField: '$',
            showAllSelectedText: false,
        };

        const texts = {
            checkAll: l10nService.localize('Select All'),
            uncheckAll: l10nService.localize('Unselect All'),
            selectionCount: l10nService.localize('Selected'),
            selectionOf: '/',
            searchPlaceholder: l10nService.localize('Search') + '...',
            buttonDefaultText: l10nService.localize('Any'),
            dynamicButtonTextSuffix: l10nService.localize('Selected'),
            disableSearch: l10nService.localize('Disable search'),
            enableSearch: l10nService.localize('Enable search'),
            selectGroup: l10nService.localize('Select all') + ':',
            allSelectedText: l10nService.localize('All'),
        };

        const input = {
            searchFilter: $scope.searchFilter || '',
        };

        angular.extend(settings, $scope.extraSettings || []);
        angular.extend(externalEvents, $scope.events || []);
        angular.extend(texts, $scope.translationTexts);
        angular.extend($scope, {
            checkboxClick,
            externalEvents,
            settings,
            texts,
            input,
            close,
            getButtonText,
            getPropertyForObject,
            selectAll,
            deselectAll,
            setSelectedItem,
            isChecked,
            openDropdownMenu,
            clickOutsideDropdown,
            keyDownSearchDefault,
            keyDownSearch,
            getFilter,
            showSearchOption,
            getIndexByProperty,
        });

        $scope.externalEvents.onInitDone();

        function getIndexByProperty(collection, objectToFind, property) {
            let index = -1;
            collection.some((option, ind) => {
                if (option[property] === objectToFind[property]) {
                    index = ind;
                    return true;
                }
                return false;
            });
            return index;
        }

        function focusFirstOption() {
            setTimeout(() => {
                const elementToFocus = angular.element($element)[0].querySelector('.option');
                if (angular.isDefined(elementToFocus) && elementToFocus !== null) {
                    elementToFocus.focus();
                }
            }, 0);
        }

        function openDropdownMenu() {
            const element = angular.element(document).find('.travellers-dropdown.active');
            const body = angular.element(document).find('body');
            $timeout(() => {
                body.addClass('dropdown-open');
            }, 400);
            $scope.element.toggleClass('active');
            $scope.btn.add('active');
            if ($scope.element.hasClass('active')) {
                $scope.opened = true;
                $scope.expanded = true;

                if ($scope.settings.enableSearch && $scope.options.length > 10) {
                    if ($scope.opened) {
                        setTimeout(() => {
                            angular.element($element)[0].querySelector('.searchField').focus();
                        }, 0);
                    }
                }
            } else {
                $scope.btn.remove('active');
                $scope.opened = false;
                $scope.expanded = false;
            }
            if (element.length === 0) {
                body.removeClass('dropdown-open');
            }
        }

        function clickOutsideDropdown() {
            if ($scope.element.hasClass('active') && $scope.opened) {
                $scope.element.removeClass('active');
                $scope.btn.removeClass('active');
                $scope.opened = false;
                $scope.expanded = false;
                $scope.input.searchFilter = $scope.settings.clearSearchOnClose ? '' : $scope.input.searchFilter;
            }
        }

        function checkboxClick($event, option) {
            $scope.setSelectedItem(option, false, true);
            $event.stopImmediatePropagation();
        }

        function close() {
            clickOutsideDropdown();
            $scope.externalEvents.onClose();
        }

        function textWidth(text) {
            const $btn = $element.find('button');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            ctx.font = $btn.css('font-size') + $btn.css('font-family');
            ctx.originalFont = $btn.css('font-size') + $btn.css('font-family');
            ctx.fillStyle = '#000000';
            return ctx.measureText(text).width;
        }

        function getButtonText() {
            if ($scope.settings.dynamicTitle && $scope.model && $scope.model.length > 0) {
                if (angular.isFunction($scope.settings.smartButtonTextProvider)) {
                    return $scope.settings.smartButtonTextProvider($scope.model);
                }

                if ($scope.settings.smartButtonMaxItems > 0) {
                    const paddingWidth = 12 * 2;
                    const borderWidth = 1 * 2;
                    const dropdownIconWidth = 8;
                    const widthLimit = $element[0].offsetWidth - paddingWidth - borderWidth - dropdownIconWidth;

                    let itemsText = [];

                    angular.forEach($scope.options, (optionItem) => {
                        if ($scope.isChecked(optionItem)) {
                            const displayText = $scope.getPropertyForObject(optionItem, $scope.settings.displayProp);
                            const converterResponse = $scope.settings.smartButtonTextConverter(displayText, optionItem);
                            itemsText.push(converterResponse || displayText);
                        }
                    });

                    if ($scope.model.length > $scope.settings.smartButtonMaxItems) {
                        itemsText = itemsText.slice(0, $scope.settings.smartButtonMaxItems);
                        itemsText.push('...');
                    }

                    let result = itemsText.join(', ');
                    let index = result.length - 4;
                    if ($element[0].offsetWidth === 0) {
                        return result;
                    }
                    if (widthLimit <= textWidth('...')) {
                        return '...';
                    }
                    while (textWidth(result) > widthLimit) {
                        if (itemsText[itemsText.length - 1] !== '...') {
                            itemsText.push('...');
                            result = `${result}...`;
                            index = result.length - 4;
                        }
                        result = result.slice(0, index) + result.slice(index + 1);
                        index -= 1;
                    }

                    return result;
                }
                const totalSelected = angular.isDefined($scope.model) ? $scope.model.length : 0;

                if (totalSelected === 0) {
                    return $scope.texts.buttonDefaultText;
                }

                if ($scope.settings.showAllSelectedText && totalSelected === $scope.options.length) {
                    return $scope.texts.allSelectedText;
                }

                if (totalSelected === 1) {
                    return getPropertyForObject($scope.model[0], settings.displayProp);
                }

                return `${totalSelected} ${$scope.texts.dynamicButtonTextSuffix}`;
            }
            return $scope.texts.buttonDefaultText;
        }

        function getPropertyForObject(object, property) {
            if (
                angular.isDefined(object)
                && Object.prototype.hasOwnProperty.call(object, property)
            ) {
                return object[property];
            }
            return undefined;
        }

        function selectAll() {
            $scope.deselectAll(true);
            $scope.externalEvents.onSelectAll();

            const searchResult = $filter('filter')($scope.options, $scope.getFilter($scope.input.searchFilter));
            angular.forEach(searchResult, (value) => {
                $scope.setSelectedItem(value, true, false);
            });

            angular.forEach($scope.options, (value) => {
                $scope.setSelectedItem(value, true, false);
            });

            $scope.externalEvents.onSelectionChanged();
            $scope.selectedGroup = null;
        }

        function deselectAll(dontSendEvent = false) {
            if (!dontSendEvent) {
                $scope.externalEvents.onDeselectAll();
            }

            $scope.model.splice(0, $scope.model.length);

            if (!dontSendEvent) {
                $scope.externalEvents.onSelectionChanged();
            }
        }

        function setSelectedItem(option, dontRemove = false, fireSelectionChange) {
            let exists;
            let indexOfOption;

            if (angular.isDefined(settings.idProperty)) {
                exists
                    = getIndexByProperty(
                        $scope.model,
                        option,
                        settings.idProperty
                    ) !== -1;
                indexOfOption = getIndexByProperty(
                    $scope.model,
                    option,
                    settings.idProperty
                );
            } else {
                exists = $scope.model.indexOf(option) !== -1;
                indexOfOption = $scope.model.indexOf(option);
            }

            if (!dontRemove && exists) {
                $scope.model.splice(indexOfOption, 1);
                $scope.externalEvents.onItemDeselect(option);
                if ($scope.settings.closeOnDeselect) {
                    $scope.close();
                }
            } else if (
                !exists
                && ($scope.settings.selectionLimit === 0 || $scope.model.length < $scope.settings.selectionLimit)
            ) {
                $scope.model.push(option);
                if (fireSelectionChange) {
                    $scope.externalEvents.onItemSelect(option);
                }
                if ($scope.settings.closeOnSelect) {
                    $scope.close();
                }
                if (
                    $scope.settings.selectionLimit > 0
                    && $scope.model.length === $scope.settings.selectionLimit
                ) {
                    $scope.externalEvents.onMaxSelectionReached();
                }
            } else if (
                $scope.settings.selectionLimit === 1
                && !exists
                && $scope.model.length === $scope.settings.selectionLimit
            ) {
                $scope.model.splice(0, 1);
                $scope.model.push(option);
                if (fireSelectionChange) {
                    $scope.externalEvents.onItemSelect(option);
                }
                if ($scope.settings.closeOnSelect) {
                    $scope.close();
                }
            }
            if (fireSelectionChange) {
                $scope.externalEvents.onSelectionChanged();
            }
            $scope.selectedGroup = null;
        }

        function isChecked(option) {
            if (angular.isDefined(settings.idProperty)) {
                return (
                    getIndexByProperty(
                        $scope.model,
                        option,
                        settings.idProperty
                    ) !== -1
                );
            }
            return $scope.model.indexOf(option) !== -1;
        }

        function keyDownSearchDefault(event) {
            let parent = event.target.parentNode.parentNode;
            let nextOption;
            if (!$scope.settings.keyboardControls) {
                return;
            }
            if (event.keyCode === 9 || event.keyCode === 40) { // tab
                event.preventDefault();
                focusFirstOption();
            } else if (event.keyCode === 38) {
                event.preventDefault();
                if (parent.previousElementSibling) {
                    nextOption = parent.previousElementSibling.querySelector('input');
                }
                while (!nextOption && !!parent) {
                    parent = parent.previousElementSibling;
                    if (parent) {
                        nextOption = parent.querySelector('input');
                    }
                }
                if (nextOption) {
                    nextOption.focus();
                }
            } else if (event.keyCode === 27) {
                event.preventDefault();
                $scope.toggleDropdown();
            }
        }

        function keyDownSearch(event, searchFilter) {
            let searchResult;
            if (!$scope.settings.keyboardControls) {
                return;
            }
            if (event.keyCode === 13) {
                if ($scope.settings.selectionLimit === 1 && $scope.settings.enableSearch) {
                    searchResult = $filter('filter')($scope.options, $scope.getFilter(searchFilter));
                    if (searchResult.length === 1) {
                        $scope.setSelectedItem(searchResult[0], false, true);
                    }
                } else if ($scope.settings.enableSearch) {
                    $scope.selectAll();
                }
            }
        }

        function getFilter(searchFilter) {
            const filter = {};
            filter[$scope.settings.searchField] = searchFilter;
            return filter;
        }

        function showSearchOption() {
            return settings.enableSearch && $scope.options.length > settings.enableSearchLimit;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/atc/directives/dropdown-multiselect-kt.directive.js